module.exports = __webpack_public_path__ + "img/aboutUsImg10.79c3c497.png";